// Local-timezone date helpers.
//
// Avoids the UTC off-by-one bug where extracting a date via toISOString()
// returns TOMORROW's date once the local clock is past ~8pm US-Eastern (because
// toISOString() converts to UTC, which has already rolled to the next day).
// These helpers read the calendar date in the browser's LOCAL timezone, which is
// what "today" means for a user entering attendance/assessments.

export function toLocalDateStr(d) {
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function todayStr() {
  return toLocalDateStr(new Date());
}

// Local-timezone "YYYY-MM-DDTHH:mm" for a datetime-local input default.
// Using toISOString() here would show UTC time (and tomorrow's date after ~8pm ET).
export function nowLocalDateTimeStr() {
  const dt = new Date();
  const h = String(dt.getHours()).padStart(2, "0");
  const min = String(dt.getMinutes()).padStart(2, "0");
  return `${toLocalDateStr(dt)}T${h}:${min}`;
}
